import axios from 'axios';
import { useFormik } from 'formik'
import React, { useEffect, useState } from 'react'
import { toast } from 'react-toastify';
import * as Yup from "yup";
import Cookies from "js-cookie";
import { adminMainUrl } from '../../../Config';

const SellingPriceForm = ({ i, id, index, showPageLoader, setShowPageLoader, handleUpdateClick, token, refresh, sellingPrice }) => {

    const [disabled, setDisabled] = useState(false);

    let user_id = Cookies.get('flexichain_user_id');


    const formik = useFormik({
        initialValues: { selling_price: '' },
        validationSchema: Yup.object({
            selling_price: Yup.number().required("Please enter selling price")
        }),
        onSubmit: (values, { resetForm }) => {
            setShowPageLoader(true);
            setDisabled(true);
            try {
                if (!id) {
                    toast.error("Tarrif id not found.");
                    return;
                }
                values.id = id;

                const config = { headers: { 'auth-token': token, "user_id": user_id } };

                axios.post(`${adminMainUrl}/api/quotation/give-selling-price`, values, config)
                    .then(response => {
                        if (response.status === 200) {
                            toast.success(response?.data?.msg);
                            handleUpdateClick(i, index);
                            setDisabled(false);
                            refresh();
                            setShowPageLoader(false);
                        } else {
                            toast.error(response?.data?.msg);
                            setDisabled(false);
                            setShowPageLoader(false);
                        }
                    }).catch(error => {
                        console.log(error.message);
                        setDisabled(false);
                        toast.error(error.response.data.msg);
                        setShowPageLoader(false);
                    })

            } catch (error) {
                console.log(error.message);
                setDisabled(false);
                toast.error(error.response.data.msg);
                setShowPageLoader(false);
            }
        }
    });

    useEffect(() => {
        if (sellingPrice) {
            // console.log("------>",i,sellingPrice);
            formik.setFieldValue("selling_price", sellingPrice)
        }
    }, [sellingPrice])

    return (
        <>
            <form onSubmit={formik.handleSubmit}>
                <div className="d-flex">
                    <div>
                        <input
                            type="number"
                            className="form-control-sm"
                            name="selling_price"
                            maxLength={8}
                            // value={editedPrice}
                            value={formik.values.selling_price}
                            onBlur={formik.handleBlur}
                            onChange={formik.handleChange}
                        />
                        {formik.errors.selling_price && formik.touched.selling_price && (
                            <div className="text-red-500 text-base">{formik.errors.selling_price}</div>
                        )}
                    </div>

                    <button type='submit' className="btn btn-sm btn-outline-success ms-1" disabled={disabled}><i className="fa-solid fa-check"></i></button>
                </div>
            </form>
        </>
    )
}

export default SellingPriceForm